export default __webpack_public_path__ + "media/images/corporate/apartments/third_slide_lg-bf50a6d4d43d051f3558995a6211da34.png";